import React from "react";

export const General = () => {
  return <div>work in progress</div>;
};
